import Vue from 'vue'
import Router from 'vue-router'
import ScoreController from '@/components/ScoreController'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ScoreController',
      component: ScoreController
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js